// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1txLU","upload":"Small_upload__3CvaQ","imageWrap":"Small_imageWrap__2LvSa","removeBtn":"Small_removeBtn__3TYYw"};